import React, { useState } from "react";
import { Box, Typography, Button, Stack, Select, MenuItem, ListSubheader, Divider } from "@mui/material";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import ImageIcon from "@mui/icons-material/Image";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import CircleIcon from "@mui/icons-material/RadioButtonUnchecked";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import ViewListIcon from "@mui/icons-material/ViewList";
import BusinessIcon from "@mui/icons-material/Business";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import { PLACEHOLDER_FIELDS } from "../utils/placeholderFields";

const groupedFields = PLACEHOLDER_FIELDS.reduce((acc, f) => {
  acc[f.group] = acc[f.group] || [];
  acc[f.group].push(f);
  return acc;
}, {});

const LeftPanel = ({ onAdd, onAddDynamicField }) => {
  const [dynField, setDynField] = useState("");

  return (
    <Box sx={{ width: 220, p: 2, borderRight: "1px solid #eee", height: "100%", overflowY: "auto" }}>
      <Typography variant="subtitle2" fontWeight={700} gutterBottom>
        Add Elements
      </Typography>
      <Stack spacing={1}>
        <Button startIcon={<TextFieldsIcon />} variant="outlined" size="small" onClick={() => onAdd("text")}>
          Text
        </Button>
        <Button startIcon={<ImageIcon />} variant="outlined" size="small" onClick={() => onAdd("image")}>
          Image
        </Button>
        <Button startIcon={<BusinessIcon />} variant="outlined" size="small" onClick={() => onAdd("logo")}>
          Logo
        </Button>
        <Button startIcon={<CropSquareIcon />} variant="outlined" size="small" onClick={() => onAdd("rect")}>
          Rectangle
        </Button>
        <Button startIcon={<CircleIcon />} variant="outlined" size="small" onClick={() => onAdd("circle")}>
          Circle
        </Button>
        <Button startIcon={<HorizontalRuleIcon />} variant="outlined" size="small" onClick={() => onAdd("line")}>
          Line
        </Button>
        <Button startIcon={<QrCode2Icon />} variant="outlined" size="small" onClick={() => onAdd("barcode")}>
          Barcode
        </Button>
        <Button startIcon={<QrCode2Icon />} variant="outlined" size="small" onClick={() => onAdd("qr")}>
          QR Code
        </Button>
        <Button startIcon={<RestaurantMenuIcon />} variant="outlined" size="small" onClick={() => onAdd("nutrition")}>
          Nutrition Table
        </Button>
      </Stack>

      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle2" fontWeight={700} gutterBottom>
        <ViewListIcon fontSize="small" sx={{ verticalAlign: "middle", mr: 0.5 }} />
        Dynamic Fields
      </Typography>
      <Select
        size="small"
        fullWidth
        displayEmpty
        value={dynField}
        onChange={(e) => {
          const field = PLACEHOLDER_FIELDS.find((f) => f.key === e.target.value);
          if (field) onAddDynamicField(field.key, field.label);
          setDynField("");
        }}
      >
        <MenuItem value="" disabled>
          Insert field...
        </MenuItem>
        {Object.entries(groupedFields).map(([group, fields]) => [
          <ListSubheader key={group}>{group}</ListSubheader>,
          ...fields.map((f) => (
            <MenuItem key={f.key} value={f.key}>
              {f.label}
            </MenuItem>
          )),
        ])}
      </Select>
    </Box>
  );
};

export default LeftPanel;
